/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-10-12 09:48:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-10-13 10:34:33
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/api/advert.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 获取广告申请列表
export function getAdvertList(params) {
  return request({
    url: '/user/admin/advertising/getApply',
    method: 'GET',
    params,
  })
}

// 修改广告申请状态

export function upDateAdvertStatus(advertisingCode, status) {
  return request({
    url: `/user/admin/advertising/updateStatus/${advertisingCode}/${status}`,
    method: 'POST',
  })
}

// 展会管理员----获取广告上架接口
export function getAvertisingList(params) {
  return request({
    url: `/user/admin/advertising/query/hostAdvertising`,
    method: 'GET',
    params,
  })
}

// 展会管理员---广告上架信息回查

export function getAdvertisingConfig(params) {
  return request({
    url: `/user/admin/advertising/query/advertisingConfig`,
    method: 'GET',
    params,
  })
}

// 展会管理员----广告上架接口
export function saveAdvertisingConfig(data) {
  return request({
    url: `/user/admin/advertising/save/advertisingConfig`,
    method: 'POST',
    data,
  })
}

// 展会管理员----修改广告上架状态
export function changeAdvertisingConfigStatus(code, status) {
  return request({
    url: `/user/admin/advertising/publish/hostAdvertising/${code}/${status}`,
    method: 'POST',
  })
}
